/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState, CountryData } from '../store/interfaces';

import { LanguageSwitcher } from '../components/LanguageSwitcher'
import { uiSetCountry, uiShowCountryChangeInfo } from '../store/actions';

const mapStateToProps = (state: ApplicationState) => {
    return {
        country: state.ui.country
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUiSetCountry: (country: CountryData) => {
            dispatch(uiSetCountry(country));
        },
        onUiShowCountryChangeInfo: (showCountryChangeInfo: boolean) => {
            dispatch(uiShowCountryChangeInfo(showCountryChangeInfo));
        }
    }
}

const LanguageSwitcherContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LanguageSwitcher)

export default LanguageSwitcherContainer